module.exports = __webpack_public_path__ + "static/media/  (13).39161487.jpg";